<template>
  <div class="create-form">
    <div class="fixed-tab">
      <div class="float-tabs">
        <div class="float-header">
          <img src="../../assets/images/apply/float-tab.svg" alt="">
          <span>申请表目录</span>
        </div>
        <div class="float-tab-list">
          <div class="float-tab-item" v-for="(item, index) in tabList" :key="index" @click="goAnchor(item.id, 1)" :class="{'is-active': item.id === activeTab}">
            <span>{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
    <ApplyInfo v-if="isCs" :isCs="isCs" :linkDisabled="linkDisabled" ref="ApplyInfo" :commonProps="commonProps" :data="applyInfo" :reportLuaCode="reportLuaCode" @updateApplyInfo="updateApplyInfo" @qryBaseSample="qryBaseSample"></ApplyInfo>
    <ApplyInfo v-if="!isCs" :isLogin="isLogin" ref="ApplyInfo" :commonProps="commonProps" :disabledAll="disabledAll"
                :linkDisabled="linkDisabled" :data="applyInfo" :userInfo="userInfo" :loginSuccess="loginSuccess"
                @loginEmit="loginEmit" :reportLuaCode="reportLuaCode" @updateApplyInfo="updateApplyInfo" @qryBaseSample="qryBaseSample"></ApplyInfo>
    <div :class="{ 'cs-form': isCs }">
      <el-form class="" :model="form" :rules="rules" ref="orderInfoForm" label-width="165px" label-position="right">
        <div class="invoice-module module" id="pay-info">
          <div class="module-label">
            付款方/开票需求
<!--            <el-checkbox v-model="isCopyApply" v-if="!disabledAll" @change="copyApplyToPay" class="copy-checkbox">联系人同申请方</el-checkbox>-->
          </div>
          <el-form-item label-width="0" v-if="invoiceData.invoiceTitle" class="no-error">
            <div class="invoice-content" :class="{ 'need-address': invoiceData.invoiceType === 3 }" v-if="invoiceData.invoiceTitle">
              <div class="invoice-item">
                <span class="label">发票类型：</span>
                <span class="detail">{{ invoiceData.invoiceType === 3 ? '增值税电子专用发票' : '增值税电子普通发票' }}</span>
              </div>
              <div class="invoice-item" v-if="invoiceData.invoiceType !== 3">
                <span class="label">抬头类型：</span>
                <span class="detail">{{ invoiceData.invoiceType === 1 ? '公司' : '个人' }}</span>
              </div>
              <div class="invoice-item">
                <span class="label">{{ invoiceData.invoiceType === 2 ? '姓名：' : showNewForeign ? '公司名称：' : '发票抬头：' }}</span>
                <span class="detail">
                  {{ invoiceData.invoiceTitle }}
                  <span class="edit-btn" @click="openEmail" v-if="!disabledAll">修改</span>
                </span>
              </div>
              <template v-if="invoiceData.invoiceType !== 2">
                <template v-if="showNewForeign">
                  <div class="invoice-item">
                    <span class="label">税号或注册证号：</span>
                    <span class="detail">{{ invoiceData.taxNo }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">国家及地区：</span>
                    <span class="detail">{{ invoiceData.country }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">城市：</span>
                    <span class="detail">{{ invoiceData.foreignCity }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">地址：</span>
                    <span class="detail">{{ invoiceData.regAddress }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">邮编：</span>
                    <span class="detail">{{ invoiceData.postCode }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">联系人：</span>
                    <span class="detail">{{ invoiceData.contact }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">电话：</span>
                    <span class="detail">{{ invoiceData.regPhone }}</span>
                  </div>
                </template>
                <template v-else>
                  <div class="invoice-item">
                    <span class="label">税号：</span>
                    <span class="detail">{{ invoiceData.taxNo }}{{ invoiceData.isForeign === 1 ? '(境外公司)' : '' }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">公司地址：</span>
                    <span class="detail">{{ invoiceData.regAddress }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">公司电话：</span>
                    <span class="detail">{{ invoiceData.regPhone }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">开户银行：</span>
                    <span class="detail">{{ invoiceData.bankName }}</span>
                  </div>
                  <div class="invoice-item">
                    <span class="label">银行账号：</span>
                    <span class="detail">{{ invoiceData.bankNumber }}</span>
                  </div>
                </template>
              </template>
              <template v-if="invoiceData.invoiceType === 2">
                <div class="invoice-item">
                  <span class="label">联系电话：</span>
                  <span class="detail">{{ invoiceData.regPhone }}</span>
                </div>
                <div class="invoice-item">
                  <span class="label">身份证号：</span>
                  <span class="detail">{{ invoiceData.taxNo }}</span>
                </div>
              </template>
            </div>
          </el-form-item>
          <el-form-item v-else prop="invoiceId" label="公司名称" class="is-required">
            <div class="invoice-btn" @click="openEmail">+ 从发票簿选择</div>
          </el-form-item>
          <el-form-item label="发票邮寄地址" class="is-required text-item" prop="invoiceAddressId" v-if="invoiceData.invoiceType === 3 && invoiceAddressData.userPhone">
            {{ invoiceAddressData.province }} {{ invoiceAddressData.city }} {{ invoiceAddressData.town }}
            {{ invoiceAddressData.companyAddress }}{{ invoiceAddressData.companyName ? '，' + invoiceAddressData.companyName + '，' : '，' }}
            {{ invoiceAddressData.userName }}，{{ invoiceAddressData.userPhone }}
          </el-form-item>
          <div class="divider"></div>
          <el-row style="padding-right: 46px;">
            <el-col :span="24" style="display: flex">
              <el-form-item label="付款方联系人">
                <el-button class="copy-btn" @click="copyApplyToPay" :disabled="disabledAll" style="margin-left: 0;">同申请方信息</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="orderInvoice.payerName" :rules="rules.payerName" class="is-required application" label="姓名">
                <el-input placeholder="" v-model="form.orderInvoice.payerName" maxlength="20" :disabled="disabledAll"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="orderInvoice.payerPhone" :rules="rules.payerPhone" label="手机号码" class="is-required application">
                <el-input placeholder="" v-model="form.orderInvoice.payerPhone" maxlength="50" :disabled="disabledAll"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="orderInvoice.payerEmail" :rules="rules.payerEmail" label="电子邮箱" class="is-required application">
                <el-input placeholder="" v-model="form.orderInvoice.payerEmail" maxlength="200" :disabled="disabledAll"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="padding-right: 46px;">
            <el-col :span="8">
              <el-form-item prop="orderInvoice.orderLinkList.0.linkEmail" :rules="rules.linkEmail" label="发票发送邮箱" class="is-required application">
                <el-input v-for="(item, index) in form.orderInvoice.orderLinkList" :key="index" placeholder="" v-model="item.linkEmail" maxlength="200" :disabled="disabledAll"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
<!--              <el-checkbox v-model="isPayEmail" v-if="!disabledAll" @change="copyPayEmail" class="copy-checkbox">同付款方联系人邮箱</el-checkbox>-->
              <el-button class="copy-btn" @click="copyPayEmail" :disabled="disabledAll">使用付款方邮箱</el-button>
            </el-col>
          </el-row>
        </div>
        <div class="module spec-tips" id="invoice-list" v-if="(formInfo.orderBase && formInfo.orderBase.state === 80 || !isOiq && invoiceFileListData && invoiceFileListData.length)&&notShare&&!isCreate" v-loading="downloadLoading">
          <div class="module-label">发票下载</div>
          <div class="report-content" v-if="invoiceFileListData && invoiceFileListData.length">
            <div class="report-list-tips">
              {{ orderNo }}共有<span
              style="color:#FF0000;font-weight: bold">{{ invoiceFileListData.length }}</span>份发票，请点击文件名下载单个发票
              <template v-if="!invoiceFileListData.some(v => v.uploadType === 1)">
                ，您也可以<span class="download-report-btn" @click="downloadReportList">全部下载</span>
              </template>
            </div>
            <div class="report-list">
              <div class="report-item" v-for="(item, index) in invoiceFileListData" :key="index">
                <span class="icon"></span>
                <span class="file" @click="downloadFile(item)" v-if="item.uploadType === 2">{{ item.fileName }}</span>
                <a class="file" :href="item.fileUrl" target="_blank" v-else>{{orderNo}}发票{{index+1}}</a>
              </div>
            </div>
          </div>
          <div class="report-content" v-if="!invoiceFileListData || !invoiceFileListData.length">
            您的发票正在开具中，请耐心等待。
          </div>
        </div>
        <div class="module report-module" style="padding-bottom: 14px;" id="report-info">
          <div class="module-label">报告要求</div>
          <el-row style="padding-right: 46px;">
            <el-col :span="8">
              <el-form-item label="报告语言" class="is-required" :rules="rules.reportLuaCode" prop="report.reportLuaCode">
                <el-select v-if="!isOiq" v-model="form.report.reportLuaCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;">
                  <el-option v-for="item in reportLuaList" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
                  </el-option>
                </el-select>
                <el-input v-else disabled v-model="form.report.reportLuaValue"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="报告形式" class="is-required" :rules="rules.reportFormCode" prop="report.reportFormCode">
                <el-select v-if="!isOiq" v-model="form.report.reportFormCode" placeholder="请选择" :disabled="disabledAll" style="width: 100%;">
                  <el-option v-for="item in reportFormList" :key="item.enumCode" :label="item.enumName" :value="item.enumCode">
                  </el-option>
                </el-select>
                <el-input v-else disabled v-model="form.report.reportFormValue"></el-input>
                <!--   v-if="reportLuaCode === 'ZNANDEN' || (form.report.reportFormCode && form.report.reportFormCode != 2)"  -->
                <el-tooltip class="item" effect="dark" content="如需要纸质报告或双语报告，增加费用以业务员实际报价为准。" placement="top">
                  <img class="item-tips" src="../../assets/images/apply/tips.png" alt="">
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="报告抬头" class="is-required reportTitleType" :rules="rules.reportTitleType" prop="report.reportTitleType">
                <el-radio-group v-model="form.report.reportTitleType" :disabled="disabledAll">
                  <el-radio :label="0">申请方</el-radio>
                  <el-radio :label="1">付款方</el-radio>
                  <el-radio :label="2">其他抬头</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :span="24" style="padding-left: 165px;" v-if="form.report.reportTitleType !== ''">
              <div class="report-form">
                <div class="report-form-item">
                  <div class="label">公司名称：</div>
                  <div class="content" v-if="form.report.reportTitleType === 0 || (form.report.reportTitleType === 1 && invoiceData.invoiceType !== 2)">
                    {{form.report.reportTitleType === 0 ? form.application.companyNameCn : invoiceData.invoiceTitle}}
                  </div>
                  <el-form-item prop="report.reportCompanyNameCn" :rules="rules.reportCompanyNameCn" label-width="0" class="is-required" v-else>
                    <el-input placeholder="" v-model="form.report.reportCompanyNameCn" maxlength="200" :disabled="disabledAll"></el-input>
                  </el-form-item>
                </div>
                <div class="report-form-item">
                  <div class="label">公司地址：</div>
                  <div class="content" v-if="form.report.reportTitleType === 0 || (form.report.reportTitleType === 1 && invoiceData.invoiceType !== 2)">
                    {{form.report.reportTitleType === 0 ? form.application.companyAddressCn : invoiceData.regAddress}}
                  </div>
                  <el-form-item prop="report.reportAddressCn" :rules="rules.reportAddressCn" label-width="0" class="is-required" v-else>
                    <el-input placeholder="" v-model="form.report.reportAddressCn" maxlength="300" :disabled="disabledAll"></el-input>
                  </el-form-item>
                </div>
                <div class="report-form-item">
                  <div class="label">Company Name：</div>
                  <div class="content" v-if="form.report.reportTitleType === 0">
                    {{form.application.companyNameEn}}
                  </div>
                  <el-form-item prop="report.reportCompanyNameEn" :rules="rules.reportCompanyNameEn" label-width="0" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' }" v-else>
                    <el-input placeholder="" v-model="form.report.reportCompanyNameEn" maxlength="300" :disabled="disabledAll"></el-input>
                  </el-form-item>
                </div>
                <div class="report-form-item">
                  <div class="label">Company Address：</div>
                  <div class="content" v-if="form.report.reportTitleType === 0">
                    {{form.application.companyAddressEn}}
                  </div>
                  <el-form-item prop="report.reportAddressEn" :rules="rules.reportAddressEn" label-width="0" :class="{ 'is-required': reportLuaCode && reportLuaCode !== 'ZN' }" v-else>
                    <el-input placeholder="" v-model="form.report.reportAddressEn" maxlength="400" :disabled="disabledAll"></el-input>
                  </el-form-item>
                </div>
              </div>
            </el-col>
            <el-col :span="24">
              <el-form-item label="报告出具要求" class="is-required" prop="report.reportMethod" :rules="rules.reportMethod">
                <el-radio-group v-model="form.report.reportMethod" :disabled="disabledAll">
                  <el-radio v-for="item in reportMethodData" :key="item.value" :label="item.value">{{item.label}}</el-radio>
                </el-radio-group>
                <el-input placeholder="请输入报告出具要求" maxlength="200" v-model="form.report.reportMethodMemo"
                          style="width: 320px;margin-left: 20px;"
                          v-if="form.report.reportMethod === 3"
                          :disabled="disabledAll" class="other_report"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="报告邮寄地址" class="is-required" :class="{ 'no-error': reportAddressData.length }" prop="report.addressList" :rules="rules.reportAddress" v-if="form.report.reportFormCode && form.report.reportFormCode != 2">
                <el-button class="common-btn" @click="openAddress('reportAddressData')" v-if="!reportAddressData.length" :disabled="disabledAll">+接收地址</el-button>
                <div v-for="(item, index) in reportAddressData" :key="index">
                    <span>{{ item.userAddressDTO.province }} {{ item.userAddressDTO.city }} {{ item.userAddressDTO.town }}{{ item.userAddressDTO.companyAddress }}{{ item.userAddressDTO.companyName ? '，' + item.userAddressDTO.companyName : '，' }}</span>
                    {{ item.userAddressDTO.userName }}，{{ item.userAddressDTO.userPhone }}
                    <span class="edit-address-btn" @click="openAddress('reportAddressData', index)" v-if="!disabledAll">修改</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="24" class="reportEmail">
              <el-form-item label="报告发送邮箱" class="is-required" :class="{'is-error': showAddEmailErr}">
                <span class="email-item" style="margin-right: 20px;">{{form.application.linkEmail}}(申请方)</span>
                <span v-for="(item, index) in form.report.orderLinkList" :key="index" class="email-item">
                  {{ item.linkEmail }}
                  <el-button type="text" @click="delEmail(index)" class="del-email" v-if="!disabledAll">删除</el-button>
                </span>
                <div class="add-email-input" v-show="isAddEmail">
                  <div>
                    <el-input v-model="currentEmail" @keyup.enter.native="saveEmail" ref="emailInput"
                              maxlength="200"></el-input>
                    <el-button type="primary" class="add-email" @click="saveEmail">保存</el-button>
                    <el-button class="cancel-add" @click="isAddEmail = false">取消</el-button>
                  </div>
                  <div class="err-msg" v-if="showAddEmailErr">{{ errMsg }}</div>
                </div>
                <el-button class="common-btn" :disabled="disabledAll" @click="addEmail" v-if="!isAddEmail && !disabledAll && form.report.orderLinkList.length < 10">+接收邮箱</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="module" style="padding-bottom: 31px;" v-loading="sampleLoading" id="sample-info">
        <div class="module-label">
          样品信息
          <span class="tips">{{!isOiq && !form.orderBase.businessCode?'请先选择申请表类型':'以下填写的样品信息将显示到报告首页'}}</span>
        </div>
        <Sample ref="Sample" :list="sampleList" :reportLuaCode="reportLuaCode" :disabledAll="disabledAll"
          :required="required" :requiredEn="requiredEn" :basicSample="basicSample" :commonProps="commonProps" @updateSampleList="updateSampleList" @delSample="delSample"></Sample>
      </div>
      <el-form class="" :model="form" :rules="rules" ref="otherForm" label-width="165px" label-position="right">
        <div class="test-module module" id="test-info" :class="{'has-btn': form.itemList.length < 20 && !disabledAll && !commonProps.isOiq}">
          <div class="module-label">
            测试要求
            <el-button class="common-btn" @click="addChemicalsTest" v-if="form.itemList.length < 20 && !disabledAll && !commonProps.isOiq">+ 化学环保项目</el-button>
          </div>
          <el-table :data="form.itemList" border :highlight-current-row="false" class="item-table">
            <el-table-column label="序号" type="index" width="49" cell-style="index-cell" align="center"></el-table-column>
            <el-table-column label="项目名称" width="236">
              <template slot="header">
                项目名称
                <span style="color: #F56C6C;" v-if="!isCs">*</span>
              </template>
              <template slot-scope="scope">
                <div v-if="isOiq || scope.row.itemId" style="text-align: center;">
                  <span v-html="scope.row.itemName"></span> <i class="give-away-icon" v-if="scope.row.isGive === 1">赠</i>
                </div>
                <el-form-item :prop="`itemList.${scope.$index}.itemName`" :rules="rules.itemName" label-width="0" class="itemName-form-item" v-else>
                  <el-input v-model="scope.row.itemName" :disabled="disabledAll" placeholder="点击填写" maxlength="255" type="textarea" autosize resize="none">
                    <template #prefix v-if="!disabledAll">
                      <img src="../../assets/images/apply/edit.png" alt="" style="margin: 14px 0 0 5px">
                    </template>
                  </el-input>
                </el-form-item>
              </template>
            </el-table-column>
            <el-table-column label="测试样品" width="236" :resizable="false" class-name="yangpin-cell" v-if="isOiq">
              <template slot-scope="scope"
                        v-if="scope.row.sampleList && scope.row.sampleList.length">
                <template v-if="scope.row.sampleList.length === 1">
                  <div class="yangpin-tab">
                    <text-tooltip
                      :content="`${scope.row.sampleList[0].row}# ${getSampleName(scope.row.sampleList[0])}`"></text-tooltip>
                  </div>
                </template>
                <template v-if="scope.row.sampleList.length === 2">
                  <el-tooltip :disabled="getSampleName(scope.row.sampleList[0]).length < 3"
                              :content="scope.row.sampleList[0].row + '# ' + getSampleName(scope.row.sampleList[0])"
                              placement="top-start">
                    <div class="yangpin-tab">{{ scope.row.sampleList[0].row }}#
                      {{ getSampleName(scope.row.sampleList[0]).slice(0, 3) }}<span
                        v-if="getSampleName(scope.row.sampleList[0]).length > 3">...</span></div>
                  </el-tooltip>
                  <el-tooltip :disabled="getSampleName(scope.row.sampleList[1]).length < 3"
                              :content="scope.row.sampleList[1].row + '# ' + getSampleName(scope.row.sampleList[1])"
                              placement="top-start">
                    <div class="yangpin-tab">{{ scope.row.sampleList[1].row }}#
                      {{ getSampleName(scope.row.sampleList[1]).slice(0, 3) }}<span
                        v-if="getSampleName(scope.row.sampleList[1]).length > 3">...</span></div>
                  </el-tooltip>
                </template>
                <template v-if="scope.row.sampleList.length > 2">
                  <el-tooltip :disabled="getSampleName(scope.row.sampleList[0]).length < 3"
                              :content="scope.row.sampleList[0].row + '# ' + getSampleName(scope.row.sampleList[0])"
                              placement="top-start">
                    <div class="yangpin-tab">{{ scope.row.sampleList[0].row }}#
                      {{ getSampleName(scope.row.sampleList[0]).slice(0, 3) }}<span
                        v-if="getSampleName(scope.row.sampleList[0]).length > 3">...</span></div>
                  </el-tooltip>
                  <el-tooltip :disabled="getSampleName(scope.row.sampleList[1]).length < 3"
                              :content="scope.row.sampleList[1].row + '# ' + getSampleName(scope.row.sampleList[1])"
                              placement="top-start">
                    <div class="yangpin-tab">{{ scope.row.sampleList[1].row }}#
                      {{ getSampleName(scope.row.sampleList[1]).slice(0, 3) }}<span
                        v-if="getSampleName(scope.row.sampleList[1]).length > 3">...</span></div>
                  </el-tooltip>
                  <el-tooltip placement="top-start">
                    <div class="yangpin-tab">+{{ scope.row.sampleList.length - 2 }}</div>
                    <template slot="content">
                      <div v-for="(item, index) in scope.row.sampleList.slice(2)" :key="index">
                        {{ item.row }}# {{ getSampleName(item) }}
                      </div>
                    </template>
                  </el-tooltip>
                </template>
              </template>
            </el-table-column>
            <el-table-column label="测试样品" width="236" v-else>
              <template slot-scope="scope">
                <el-select v-model="scope.row.sampleNoList" placeholder="选择样品" :disabled="disabledAll" multiple>
                  <el-option v-for="(item, index) in form.sampleList" :key="item.sampleNo" :value="item.sampleNo" :label="getSampleNameInd(item, index)">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="测试标准">
              <template slot-scope="scope">
                <div style="text-align: center;" v-html="textareaWrap(scope.row.standardCode)" v-if="isOiq"></div>
                <el-input v-model="scope.row.standardCode" :disabled="disabledAll" placeholder="点击填写" maxlength="255" v-else type="textarea" autosize resize="none">
                  <template #prefix v-if="!disabledAll">
                    <img src="../../assets/images/apply/edit.png" alt="" style="margin: 14px 0 0 5px">
                  </template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="测试备注" width="232">
              <template slot-scope="scope">
                <div v-if="isOiq" style="text-align: center;">
                  <span v-html="textareaWrap(scope.row.testMemo)"></span> <qs-tips
                  :data="{ memo: scope.row.memoExplain }"></qs-tips>
                </div>
                <el-input v-model="scope.row.testMemo" :disabled="disabledAll" placeholder="点击填写" maxlength="500" v-else type="textarea" autosize resize="none">
                  <template #prefix v-if="!disabledAll">
                    <img src="../../assets/images/apply/edit.png" alt="" style="margin: 14px 0 0 5px">
                  </template>
                </el-input>
              </template>
            </el-table-column>
            <el-table-column label="是否判定" width="80">
              <template slot-scope="scope">
                <div style="text-align: center;" v-if="isOiq">{{ scope.row.isDetermine === 1 ? '是' : '否' }}</div>
                <el-switch
                  v-else
                  style="margin-left: 20px;"
                  :disabled="disabledAll"
                  v-model="scope.row.isDetermine"
                  active-color="#ca4300;"
                  :active-value="1"
                  :inactive-value="0"
                >
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="数量" v-if="isOiq" align="center">
              <template slot-scope="scope">
                {{ scope.row.buyNums }} <qs-tips v-if="scope.row.otherExplainDTO" :data="{ memo: scope.row.otherExplainDTO.numExplain }"></qs-tips>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="115" align="center" v-if="!disabledAll && !isOiq">
              <template slot-scope="scope">
                <el-button type="text" v-if="form.itemList.length !== 1" @click="delItem(scope.$index)">删除</el-button>
                <el-button type="text" v-if="scope.$index === form.itemList.length - 1 && form.itemList.length < 20"
                  @click="addTestItem">新增</el-button>
              </template>
            </el-table-column>
          </el-table>
<!--          <div class="member-tips" style="padding: 0 0 20px 0;" v-if="form.itemList.some(v => v.isDetermine)">注：如需判定，将增加判定费用￥200/份</div>-->
          <div class="memo-label">测试备注</div>
          <el-input ref="testMemoInput" id="testMemoInput" type="textarea" placeholder="请输入您的测试要求，如有相关资料，可上传文件" maxlength="200" v-model="form.application.testMemo"
            :disabled="disabledAll" class="memo-textarea"></el-input>
          <div class="chemicals-tags" v-if="!isOiq && form.itemList.some(v => v.itemId)">
            点击标签可添加化学测试要求：
            <div class="chemicals-tag" @click="tagClick(item)" v-for="(item, index) in chemicalTags" :key="index">{{item.enumName}}</div>
          </div>
          <UploadFile :api-url="host.javaUrl" v-model="form.application.testMemoImg" v-if="!disabledAll" :limit="5">
            <template #btn>
              <el-button class="upload-btn" :disabled="disabledAll || form.application.testMemoImg.length === 5">
                <img src="../../assets/images/apply/upload.png" alt="">
                技术文件上传
              </el-button>
            </template>
          </UploadFile>
          <div class="file-list" v-if="form.application.testMemoImg.length">
            <div class="file-item" v-for="(item, index) in form.application.testMemoImg" :key="index">
              <a :href="item.src" target="_blank">{{ item.name }}</a>
              <span class="del-file" @click="delFile(index)" v-if="!disabledAll">删除</span>
            </div>
          </div>
          <div style="margin-bottom: 15px;">
            <el-checkbox v-model="form.application.isTransfer" :true-label="0" :false-label="1"
              :disabled="disabledAll">不接受SGS以外的分包。若未选择，则视为接受分包</el-checkbox>
          </div>
          <div>
            <el-checkbox v-model="form.application.applicationAttr.isDispute" :true-label="1" :false-label="0"
              :disabled="disabledAll">本申请是否涉及法律纠纷？如有请勾选，并说明。</el-checkbox>
          </div>
          <el-input v-if="form.application.applicationAttr.isDispute" type="textarea" placeholder="请输入情况说明" maxlength="200"
            v-model="form.application.applicationAttr.isDisputeMemo" style="margin-top: 15px;" :disabled="disabledAll"
            class="memo-textarea"></el-input>
        </div>
        <div class="report-module module" v-loading="loading" id="service-info">
          <div class="module-label">服务要求</div>
          <el-row>
            <el-col :span="8">
              <el-form-item prop="orderBase.isUrgent" :rules="rules.isUrgent" label="周期要求" class="is-required">
                <el-input disabled v-model="form.orderBase.isUrgentShow" v-if="isOiq"></el-input>
                <template v-else>
                  <el-select v-model="form.orderBase.isUrgent" placeholder="请选择" :disabled="disabledAll">
                    <el-option v-for="item in testCycleList" :key="item.enumCode" :label="item.enumName"
                               :value="item.enumCode">
                    </el-option>
                  </el-select>
                  <div v-if="form.orderBase.isUrgent !== 1" style="word-break: keep-all;line-height: 16px;font-size: 12px;color: #878787;margin-top: 10px;">加急服务周期以业务顾问最终确认为准</div>
                </template>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item prop="application.isRefundSample" :rules="rules.isRefundSample" label="测试样品处置" class="is-required">
                <el-select v-model="form.application.isRefundSample" placeholder="请选择" :disabled="disabledAll">
                  <el-option v-for="item in refundList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="样品退回地址" class="is-required" :class="{ 'no-error': backAddressData.length }"
                            prop="application.addressList" :rules="rules.backAddress" v-if="form.application.isRefundSample === '1'">
                <el-button class="common-btn" @click="openAddress('backAddressData')" v-if="!backAddressData.length"
                           :disabled="disabledAll">+接收地址</el-button>
                <div v-for="(item, index) in backAddressData" :key="index">
                  <span>{{ item.userAddressDTO.province }} {{ item.userAddressDTO.city }} {{ item.userAddressDTO.town }}{{ item.userAddressDTO.companyAddress }}{{ item.userAddressDTO.companyName ? '，' + item.userAddressDTO.companyName : '，' }}</span>
                  {{ item.userAddressDTO.userName }}，{{ item.userAddressDTO.userPhone }}
                  <span class="edit-address-btn" @click="openAddress('backAddressData', index)" v-if="!disabledAll">修改</span>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item :prop="isOiq ? '' : 'orderBase.businessPersonEmail'" :rules="rules.businessPersonEmail" label="SGS服务顾问" class="is-required lab-item">
                <el-input placeholder="请输入服务顾问的邮箱" v-model="form.orderBase.businessPersonEmail" maxlength="50"
                          :disabled="disabledAll || hasCs || isCs || isOiq || form.application.applicationAttr.defaultEmailFlg === 1 || (!isCreate && formInfo.orderBase && formInfo.orderBase.state > 11) || csDisabled">
                  <template #suffix>
                    <img src="../../assets/images/apply/lock.png" alt="" style="margin-right: 10px;" v-if="hasCs">
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8" style="padding-top: 12px;" v-if="!isOiq && !isCs">
              <el-checkbox @change="flgChange" v-model="form.application.applicationAttr.defaultEmailFlg" :disabled="disabledAll || (!isCreate && formInfo.orderBase && formInfo.orderBase.state > 11) || hasCs || csDisabled" class="copy-checkbox" :true-label="1" :false-label="0">暂不清楚，待SGS分配</el-checkbox>
            </el-col>
            <el-col :span="24" class="reportEmail">
              <el-form-item label="订单分享" :class="{'is-error': showAddBuyerErr}">
                <span v-for="(item, index) in form.customerList" :key="index" class="email-item">
                  {{ item.customer }}
                  <el-button type="text" @click="delBuyer(index)" class="del-email" v-if="!disabledAll">删除</el-button>
                </span>
                <div class="add-email-input" v-show="isAddBuyer">
                  <div>
                    <el-input v-model="currentBuyer" @keyup.enter.native="saveBuyer" ref="buyerInput" maxlength="200" placeholder="请输入买家名称或用户账号"></el-input>
                    <el-button type="primary" class="add-email" @click="saveBuyer" :loading="addBuyerLoading">保存</el-button>
                    <el-button class="cancel-add" @click="isAddBuyer = false" :loading="addBuyerLoading">取消</el-button>
                  </div>
                  <div class="err-msg" v-if="showAddBuyerErr">{{ buyerErrMsg }}</div>
                </div>
                <el-button class="common-btn" :disabled="disabledAll" @click="addBuyer" v-if="!isAddBuyer">+添加分享对象</el-button>
              </el-form-item>
              <div class="buyer-tips">添加后，订单进度和报告将共享给对方</div>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div class="module spec-tips" id="tips-info">
        <div class="module-label">提示信息</div>
        <div>1. 若需要CMA或CNAS章，请在测试备注填写。</div>
        <div>2. 实验室的评价仅基于实验室活动的实际值，未将实验室活动的结果不确定度影响计入。</div>
        <div>3. 若未指明测试标准/产品标准及年代号，则默认为客户接受SGS推荐的测试标准/产品标准。</div>
        <div>4. 若未告知不接受分包，则视为接受。SGS将分包到认可的检测机构。</div>
        <div>5. 测试后样品会有不同程度的损坏/损耗，余样保留时间30天，逾期销毁。</div>
        <div>6. 报告正式发布后，如需进行修改，根据修改的测试内容和项目另行评估收费。</div>
      </div>
    </div>
    <template v-if="!disabledAll">
      <div class="btns" v-if="!isCs">
        <el-button v-if="formInfo.orderBase && formInfo.orderBase.state !== 11 && isEdit" type="primary"
          @click="handleSubmit(true)" :disabled="disabledAll">提交修改申请表</el-button>
        <template v-else>
          <el-button @click="handleSubmit(false)" class="staging-btn" :disabled="disabledAll">保存草稿</el-button>
          <el-button type="primary" @click="handleSubmit(true)" :disabled="disabledAll">提交申请表</el-button>
        </template>
      </div>
      <div class="btns" v-else>
        <el-button @click="handleSubmit(false)" class="staging-btn" :disabled="disabledAll">保存草稿</el-button>
<!--        <el-button type="primary" @click="copyUrl" :disabled="disabledAll" v-if="!isCreate && !isOiq">复制链接</el-button>-->
        <el-button type="primary" @click="copyUrl" :disabled="disabledAll" v-if="!isCreate || isOiq">复制链接</el-button>
        <el-button type="primary" @click="handleSubmit(true)" v-if="isOiq">提交申请表</el-button>
      </div>
    </template>
    <div class="notice" v-if="!isCs && !disabledAll">
      <el-checkbox v-model="checkNotice" v-if="loginSuccess">
        提交申请表即视为接受<a class="redColor" href="https://cmsuat.sgsonline.com.cn/overview/terms-and-conditions" target="_blank">《SGS服务通用条款》</a>
      </el-checkbox>
      <el-checkbox v-model="checkRegister" v-else>
        <span class="text">阅读并同意<em class="activeColr" @click="setTipsVisible(true)">注册</em></span>及<a class="activeColr"
          href="https://www.sgsgroup.com.cn/zh-cn/privacy-at-sgs" target="_blank">隐私条款</a>，提交申请表即视为接受<a class="redColor" href="https://cmsuat.sgsonline.com.cn/overview/terms-and-conditions" target="_blank">《SGS服务通用条款》</a>
      </el-checkbox>
    </div>
    <template v-if="!disabledAll">
      <choose-invoice v-model="emailDialog" :data.sync="invoiceData" :apis="apis" v-if="invoiceListShow" :env="env" :isCs="isCs" @addInvoice="toggleInvoice" :userId="formInfo.orderBase.userId"></choose-invoice>
      <template v-else>
        <CreateInvoiceCs v-if="isCs" v-model="emailDialog" :data.sync="invoiceData" :apis="apis" :env="env" :isCs="isCs" :isLogin="isLogin" @showList="toggleInvoice" :hasUser="hasUser && !isCreate" :isAdd="isAdd"></CreateInvoiceCs>
        <CreateInvoice v-else v-model="emailDialog" :data.sync="invoiceData" :apis="apis" :env="env" :isCs="isCs" :isLogin="isLogin"></CreateInvoice>
      </template>

      <choose-address v-model="addressDialog" :currentData.sync="currentData" @updateData="updateAddressData" @delAddress="delAddress" v-if="addressListShow" :apis="apis" @addAddress="toggleAddress" :userId="formInfo.orderBase.userId" :isCs="isCs"></choose-address>
      <CreateAddress :isAdd="isAdd" v-model="addressDialog" :data.sync="currentData" :apis="apis" @updateData="updateAddressData" v-else @showList="toggleAddress" :isCs="isCs" :hasUser="hasUser && !isCreate"></CreateAddress>
      <register-terms v-if="tipsVisible" @setTipsVisible="setTipsVisible"></register-terms>
    </template>
    <login-verify-code :env="env" :captchaAppId="'192302431'" v-model="codeShow" :number="form.application ? form.application.linkPhone : ''" :data="codeData" @loginSuccess="codeSuccess"/>
    <ChooseChemicalsItem v-model="chemicalsDialogVisible" v-if="chemicalsDialogVisible" :apis="apis" :originalList.sync="form.itemList" />
  </div>
</template>

<script>
import Sample from "./Sample.vue";
import ApplyInfo from "./ApplyInfo.vue";
import { host } from "src/config";
import ChooseInvoice from "../invoice/index.vue";
import { getEnumBatch, loginReg, qryLab, qryBaseSample } from "src/request/apis";
import UploadFile from "src/components/UploadFile/index.vue";
import {phoneReg, emailReg, tokenKey, typeOf} from "utils";
import CreateInvoice from "src/components/apply/CreateInvoice.vue";
import CreateAddress from "src/components/apply/CreateAddress.vue";
import ChooseAddress from "src/components/apply/ChooseAddress.vue";
import CreateInvoiceCs from "src/components/apply/CreateInvoiceCs.vue";
import Cookies from "js-cookie";
import md5 from 'crypto-md5'
import axios from 'axios'
import RegisterTerms from "src/components/loginMerge/RegisterTerms.vue";
import LoginVerifyCode from "src/components/loginVerifyCode/index.vue";
import TextTooltip from "src/components/textTooltip/index.vue";
import QsTips from '../newEnquiry/QsTips.vue'
import {textareaWrap} from 'utils'
import ChooseChemicalsItem from "src/components/apply/ChooseChemicalsItem.vue";

export default {
  name: "TicApply",
  components: {
    CreateAddress,
    Sample,
    ApplyInfo,
    ChooseInvoice,
    UploadFile,
    CreateInvoice,
    ChooseAddress,
    RegisterTerms,
    LoginVerifyCode,
    TextTooltip,
    QsTips,
    CreateInvoiceCs,
    ChooseChemicalsItem
  },
  props: {
    notShare: {
      type: Boolean,
      default: true
    },
    isCs: {
      type: Boolean,
      default: false
    },
    isLogin: {
      type: Boolean,
      default: false
    },
    hasUser: {
      type: Boolean,
      default: false
    },
    env: {
      type: String,
      default: 'local'
    },
    bu: {
      type: String,
      default: ''
    },
    apis: {
      type: Object,
      default() {
        return {}
      }
    },
    disabledAll: {
      type: Boolean,
      default: false
    },
    orderDetail: {
      type: Object,
      default() {
        return {}
      }
    },
    formInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    userInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    csInfo: {
      type: Object,
      default() {
        return {}
      }
    },
    queryUrlData: {
      type: Object,
      default() {
        return {}
      }
    },
    invoiceFileList: {
      type: Array,
      default() {
        return []
      }
    },
    isOiq: {
      type: Boolean,
      default: false
    },
    top: {
      type: Number,
      default: 278
    },
    businessObj: {
      type: Object,
      default: null
    }
  },
  data() {
    const validateRequired = (rule, value, callback) => {
      if (this.isSave && (!value && value !== 0 || (typeOf(value) === 'array' && !value.length))) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validateRequiredNumber = (rule, value, callback) => {
      if (this.isSave && !value && value !== 0) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validateRequiredArr = (rule, value, callback) => {
      if (this.isSave && (!value || !value.length)) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validateRequiredEn = (rule, value, callback) => {
      if (this.isSave && (this.reportLuaCode && this.reportLuaCode !== 'ZN') && !value) {
        return callback(new Error('必填项'));
      } else {
        return callback()
      }
    }
    const validatePhone = (rule, value, callback) => {
      if (value && !phoneReg.test(value)) {
        return callback(new Error('请输入正确的手机号'))
      } else {
        return callback()
      }
    }
    const validateMethod = (rule, value, callback) => {
      if (!this.isCs && this.isSave && value === 3 && !this.form.report.reportMethodMemo) {
        return callback(new Error('请输入报告出具要求'))
      } else {
        return callback()
      }
    }
    const validateEmail = (rule, value, callback) => {
      if (value && !emailReg.test(value)) {
        return callback(new Error('请输入正确的邮箱'))
      } else {
        return callback()
      }
    }
    const required = { trigger: 'change', validator: validateRequired }
    const requiredEn = { trigger: 'change', validator: validateRequiredEn }
    const validateCsEmail = (rule, value, callback) => {
      if (this.form.application.applicationAttr.defaultEmailFlg !== 1 && !value) {
        return callback(new Error('必填项'))
      } else if (value && !this.csMailReg.test(value)) {
        return callback(new Error('请输入完整的SGS服务顾问邮箱'))
      } else {
        return callback()
      }
    }
    const validateEn = (rule, value, callback) => {
      const reg = /^[^\u4e00-\u9fa5]+$/
      if (value && !reg.test(value)) {
        return callback(new Error('请输入英文字符'));
      } else {
        return callback()
      }
    }
    const validatorEn = { validator: validateEn }
    return {
      isPayEmail: false,
      phoneReg,
      codeShow: false,
      isCopyApply: false,
      csMailReg: /^[a-zA-Z0-9_.-]+@sgs.com$/,
      basicSample: {},
      required,
      requiredEn,
      sampleList: [],
      isSave: false,
      host: host(this.env),
      invoiceData: {},
      invoiceAddressData: {},
      emailDialog: false,
      form: {
        application: {
          companyNameCn: '',
          companyAddressCn: '',
          companyNameEn: '',
          companyAddressEn: '',
          testMemo: '',
          testMemoImg: [],
          isTransfer: 1,
          isRefundSample: '0',
          applicationAttr: {
            isDispute: 0,
            isDisputeMemo: '',
            defaultEmailFlg: 0
          },
        },
        report: {
          reportLuaCode: '',
          reportFormCode: '2',
          reportTitleType: '',
          reportMethod: 1,
          orderLinkList: [],
          reportMethodMemo: '',
          reportCompanyNameCn: '',
          reportAddressCn: '',
          reportCompanyNameEn: '',
          reportAddressEn: '',
        },
        orderInvoice: {
          payerName: '',
          payerPhone: '',
          payerEmail: '',
          orderLinkList: [
            {
              linkEmail: '',
            }
          ],
          invoiceId: '',
          invoice: {}
        },
        orderBase: {
          isUrgent: 1,
          businessPersonEmail: '',
        },
        reportAddressId: '',
        backAddressId: '',
        itemList: [],
        sampleList: [],
        customerList: []
      },
      rules: {
        invoiceId: [required],
        reportFormCode: [required],
        reportLuaCode: [required],
        reportMethod: [required, { validator: validateMethod }],
        isUrgent: [required],
        isRefundSample: [required],
        reportAddress: [{ trigger: 'change', validator: validateRequiredArr }],
        backAddress: [{ trigger: 'change', validator: validateRequiredArr }],
        orderLinkList: [{ trigger: 'change', validator: validateRequiredArr }],
        reportCompanyNameCn: [required],
        reportAddressCn: [required],
        reportTitleType: [{validator: validateRequiredNumber}],
        reportCompanyNameEn: [requiredEn],
        reportAddressEn: [requiredEn],
        payerName: [required],
        businessPersonEmail: [
          { validator: validateCsEmail }
        ],
        payerEmail: [required, { validator: validateEmail }],
        linkEmail: [required, { validator: validateEmail }],
        payerPhone: [required, { validator: validatePhone }],
        itemName: [required]
      },
      currentKey: {},
      currentData: {},
      addressDialog: false,
      reportMethodData: [
        { label: '一份申请对应一份报告', value: 1 },
        { label: '一个样品对应一份报告', value: 2 },
        { label: '其他', value: 3 },
      ],
      refundList: [
        { label: '不需要退回', value: '0' },
        { label: '需要退回（退回快递,顺丰到付）', value: '1' },
      ],
      reportLuaList: [],
      reportFormList: [],
      testCycleList: [],
      labList: [],
      reportAddressData: [],
      backAddressData: [],
      currentEmail: '',
      isAddEmail: false,
      showAddEmailErr: false,
      errMsg: '',
      reportSendCc: [],
      hasCs: false,
      hasLab: false,
      checkRegister: false,
      tipsVisible: false,
      domain: host(this.env).domain,
      apiUrl: host(this.env).javaUrl,
      orderNo: '',
      isAgain: false,
      isInit: false,
      isSampleInit: false,
      loginSuccess: false,
      loading: false,
      sampleLoading: false,
      loginOrderBase: null,
      isEdit: false,
      invoiceFileListData: [],
      downloadLoading: false,
      checkNotice: false,
      currentSaveData: {},
      codeData: {
        title: '验证手机号',
        sendModel: '已发送到申请方手机号：+86',
        prepend: '手机验证码'
      },
      tabList: [
        { name: '申请方信息', id: '#apply-info' },
        { name: '付款方/开票需求', id: '#pay-info' },
        { name: '报告要求', id: '#report-info' },
        { name: '样品信息', id: '#sample-info' },
        { name: '测试要求', id: '#test-info' },
        { name: '服务要求', id: '#service-info' },
        { name: '提示信息', id: '#tips-info' },
      ],
      activeTab: '#apply-info',
      currentIndex: 0,
      textareaWrap,
      isAddBuyer: false,
      currentBuyer: '',
      buyerErrMsg: '',
      showAddBuyerErr: false,
      addBuyerLoading: false,
      validatorEn,
      chemicalsDialogVisible: false,
      chemicalTags: [],
      invoiceListShow: false,
      addressListShow: false,
      isAdd: false
    }
  },
  computed: {
    commonProps() {
      return {
        env: this.env,
        apis: this.apis,
        orderNo: this.orderNo,
        isCs: this.isCs,
        isLogin: this.isLogin,
        disabledAll: this.disabledAll,
        required: this.required,
        requiredEn: this.requiredEn,
        isOiq: this.isOiq,
        isSave: this.isSave,
        bu: this.bu,
        isCreate: this.isCreate,
        formInfo: this.formInfo,
        form: this.form,
        validatorEn: this.validatorEn,
        businessObj: this.businessObj
      }
    },
    linkDisabled() {
      return !this.isCreate && ((!this.isCs && !this.isOiq && !this.isLogin) || this.isCs)
    },
    applyInfo() {
      const applyInfo = {}
      const data = this.loginOrderBase || this.formInfo.application || {}
      const orderLinkList = data.orderLinkList || []
      applyInfo.orderLinkList = JSON.parse(JSON.stringify(orderLinkList))
      applyInfo.companyNameCn = data.companyNameCn
      applyInfo.companyAddressCn = data.companyAddressCn
      applyInfo.companyNameEn = data.companyNameEn
      applyInfo.companyAddressEn = data.companyAddressEn
      if (!this.orderNo && this.isLogin) {
        applyInfo.linkPerson = this.userInfo.userName || this.userInfo.userNick
        applyInfo.linkEmail = this.userInfo.userEmail
        applyInfo.linkPhone = this.userInfo.userPhone
      } else if (this.formInfo.application) {
        applyInfo.linkPerson = this.formInfo.application.linkPerson
        applyInfo.linkEmail = this.formInfo.application.linkEmail
        applyInfo.linkPhone = this.formInfo.application.linkPhone
      }
      return applyInfo
    },
    isCreate() {
      return (!this.orderNo || this.isAgain) && !this.isOiq
    },
    allInit() {
      return this.isInit && this.isSampleInit
    },
    showNewForeign() {
      return this.invoiceData && this.invoiceData.isForeign === 1 && !(this.disabledAll && this.invoiceData.detailNo)
    },
    reportLuaCode() {
      return this.form.report.reportLuaCode
    },
    csDisabled() {
      return this.formInfo.tails == 1 && !this.isCreate
    }
  },
  watch: {
    isLogin: {
      handler(val) {
        this.loginSuccess = val
      },
      immediate: true
    },
    formInfo: {
      handler(val) {
        this.orderNo = this.$route.query.orderNo
        this.isAgain = !!this.$route.query.isAgain
        if (this.isCs && !this.$route.query.orderNo) {
          this.isInit = true
          this.addTestItem()
        }
        console.log(val.sampleList, !this.isCreate);
        if (val && val.sampleList && !this.isCreate) {
          val.sampleList.forEach(v => {
            v.sampleFromDTOList.forEach(item => {
              v[item.sampleKey] = item.sampleValue
              this.$set(v, item.sampleKey, item.sampleValue)
            })
          })
          this.sampleList = JSON.parse(JSON.stringify(val.sampleList))
          this.isInit = true
        }
        if (val.application) {
          this.form = JSON.parse(JSON.stringify(val))
          this.form.sampleList = this.sampleList
          if (!val.orderInvoice.orderLinkList.length) {
            this.form.orderInvoice.orderLinkList = [{ linkEmail: '' }]
          }
          if (this.form.orderInvoice.addressList.length) {
            this.invoiceAddressData = this.form.orderInvoice.addressList[0].userAddressDTO
          }
          this.reportAddressData = val.report.addressList || []
          this.backAddressData = val.application.addressList || []
          this.form.application.isRefundSample = String(val.application.isRefundSample)
          this.form.orderBase.businessPersonEmail = this.hasCs ? this.queryUrlData.crm : val.orderBase.businessPersonEmail
          this.form.orderBase.businessCode = val.orderBase.businessCode
          this.form.orderBase.bu = val.orderBase.bu
          this.invoiceData = val.orderInvoice.invoice || {}
          if (!this.isOiq) {
            val.itemList.forEach(v => {
              this.$set(v, 'sampleNoList', [])
              v.sampleNoList = v.sampleList.map(v => v.sampleNo)
            })
          }
          this.form.itemList = val.itemList
          if (!this.form.itemList.length && !this.disabledAll) this.addTestItem()
        }
      },
      immediate: true
    },
    queryUrlData: {
      handler(val) {
        this.orderNo = val.orderNo
        this.isAgain = !!val.isAgain
        if (this.isCs) {
          this.form.orderBase.businessPersonEmail = this.csInfo.personMail
          return
        }
        if (this.orderNo) return
        this.hasCs = this.csMailReg.test(this.queryUrlData.crm)
        if (this.hasCs) this.form.orderBase.businessPersonEmail = this.queryUrlData.crm
      },
      immediate: true
    },
    allInit(val) {
      if (val) {
        if (this.isCreate) {
          // if (!this.sampleList.length && !this.isOiq) {
          //   this.sampleList.push(JSON.parse(JSON.stringify(this.basicSample)))
          //   this.form.sampleList = this.sampleList
          //   return
          // }
          // this.sampleList.forEach(v => {
          //   v.sampleFromDTOList = JSON.parse(JSON.stringify(this.basicSample.sampleFromDTOList))
          //   v.sampleFromGoup = JSON.parse(JSON.stringify(this.basicSample.sampleFromGoup))
          // })
        } else {
          const basicSample = JSON.parse(JSON.stringify(this.sampleList[0] || {}))
          delete basicSample.sampleNo
          this.basicSample = basicSample
          this.sampleList.forEach(v => {
            v.sampleFromGoup = {}
            v.sampleFromDTOList && v.sampleFromDTOList.forEach(item => {
              item.showAttr = item.showAttr || {}
              v[item.sampleKey] = item.sampleValue
              v[item.sampleKey + 'RemarkPage'] = item.remark
              basicSample[item.sampleKey] = ''
              basicSample[item.sampleKey + 'RemarkPage'] = ''
              if (item.type === 11) {
                v[item.sampleKey] = item.sampleValue ? item.sampleValue.split(',') : []
                basicSample[item.sampleKey] = []
              }
              if (!v.sampleFromGoup[item.sampleGroup]) {
                v.sampleFromGoup[item.sampleGroup] = [item.sampleKey]
              } else {
                v.sampleFromGoup[item.sampleGroup].push(item.sampleKey)
              }
            })
          })
          this.sampleList = JSON.parse(JSON.stringify(this.sampleList))
          if(this.sampleList[0]) this.basicSample.sampleFromGoup = this.sampleList[0].sampleFromGoup
        }
      }
    },
    invoiceFileList: {
      handler(val) {
        this.invoiceFileListData = val
      },
      immediate: true
    },
  },
  mounted() {
    this.isEdit = !!this.$route.query.isEdit
    this.getBasic()
    if (this.isCreate) {
      // this.qryBaseSample()
    } else {
      this.isSampleInit = true
    }
    document.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleAddress() {
      this.addressListShow = !this.addressListShow
      this.isAdd = !this.addressListShow
      this.$nextTick(() => {
        this.addressDialog = true
      })
    },
    toggleInvoice() {
      this.invoiceListShow = !this.invoiceListShow
      this.isAdd = !this.invoiceListShow
      this.$nextTick(() => {
        this.emailDialog = true
      })
    },
    addChemicalsTest() {
      this.chemicalsDialogVisible = true
    },
    tagClick(data) {
      const testMemo = this.form.application.testMemo || ''
      this.form.application.testMemo = testMemo + data.enumName + ' '
      // const textarea = document.getElementById('testMemoInput');
      // const cursorStart = textarea.selectionStart;
      // const cursorEnd = textarea.selectionEnd;
      // this.form.application.testMemo = testMemo.slice(0, cursorStart) + data.enumName + testMemo.slice(cursorEnd);
    },
    delBuyer(index) {
      this.form.customerList.splice(index, 1)
    },
    saveBuyer() {
      return new Promise(resolve => {
        if (!this.currentBuyer) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '请输入'
          resolve(false)
          return
        }
        if (this.form.customerList.some(v => v.customer === this.currentBuyer)) {
          this.showAddBuyerErr = true
          this.buyerErrMsg = '您已添加此买家'
          resolve(false)
          return
        }
        this.addBuyerLoading = true
        this.apis.getCustomerIdList({
          customers: [this.currentBuyer]
        }).then(res => {
          if (res && res.resultCode !== '0') {
            this.showAddBuyerErr = true
            this.buyerErrMsg = res.resultMsg
            resolve(false)
            return
          }
          this.addBuyerLoading = false
          this.form.customerList = this.form.customerList.concat(res.data.items)
          this.isAddBuyer = false
          this.showAddBuyerErr = false
          resolve(true)
        }).catch(e => {
          resolve(false)
          if (e && e.resultMsg) {
            this.showAddBuyerErr = true
            this.buyerErrMsg = e.resultMsg
          }
          this.addBuyerLoading = false
        })
      })
    },
    addBuyer() {
      this.currentBuyer = ''
      this.buyerErrMsg = ''
      this.isAddBuyer = true
      this.showAddBuyerErr = false
      this.$nextTick(() => {
        this.$refs.buyerInput.focus()
      })
    },
    // 页面滚动监听方法
    handleScroll() {
      this.tabList.forEach(v => {
        const tabEl = document.querySelector(v.id);
        if (!tabEl) return
        const rect = tabEl.getBoundingClientRect().top
        if (rect <= this.top) {
          this.activeTab = v.id
        }
      })
    },
    delSample(data) {
      this.form.itemList.forEach(v => {
        v.sampleNoList = v.sampleNoList.filter(v => v !== data.sampleNo)
      })
    },
    getShow(data) {
      return data.lua === 'CHI' && this.reportLuaCode !== 'EN' || data.lua === 'EN' && this.reportLuaCode !== 'ZN'
    },
    flgChange(val) {
      if (val === 1) {
        this.form.orderBase.businessPersonEmail = ''
      }
    },
    getSampleName(data) {
      return data.SAMPLE_NAME || data.SAMPLE_NAME_EN || data.sampleName
    },
    getSampleNameInd(data, index) {
      const text = data.SAMPLE_NAME || data.SAMPLE_NAME_EN
      return index + 1 + '#' + text
    },
    updateApplyInfo(data) {
      this.form.orderBase.businessCode = data.businessCode
      this.form.orderBase.bu = data.bu
      this.form.application = Object.assign(this.form.application, data)
    },
    updateSampleList(list) {
      this.form.sampleList = list
    },
    goAnchor(selector, time) {
      this.activeTab = selector
      const second = time || 500
      // 最好加个定时器给页面缓冲时间
      setTimeout(() => {
        // 获取锚点元素
        let anchor = this.$el.querySelector(selector)
        if (anchor) {
          anchor.scrollIntoView()
        }
      }, second)
    },
    copyApplyToPay(val) {
      // if (val) {
        this.form.orderInvoice.payerName = this.form.application.linkPerson
        this.form.orderInvoice.payerPhone = this.form.application.linkPhone
        this.form.orderInvoice.payerEmail = this.form.application.linkEmail
      // }
    },
    copyPayEmail(val) {
      // if (val) {
        this.form.orderInvoice.orderLinkList[0].linkEmail = this.form.orderInvoice.payerEmail
      // }
    },
    codeSuccess() {
      this.$emit('saveForm', this.currentSaveData)
    },
    loginEmit() {
      this.loginOrderBase = this.$refs.ApplyInfo.getData()
      this.$emit('loginEmit')
    },
    copyUrl() {
      this.$emit('copyUrl', this.orderNo)
    },
    delAddress(addressId) {
      const keys = ['backAddressData', 'reportAddressData']
      if (this.step === 1) {
        keys.forEach(v => {
          this[v] = this[v].filter(v => this[v].addressId !== addressId)
        })
      }
    },
    setTipsVisible(val) {
      this.tipsVisible = val
    },
    updateAddressData(data) {
      let addressDetail = {}
      if (data.provinceData) {
        addressDetail = Object.assign(data, {
          province: data.provinceData[0],
          city: data.provinceData[1],
          town: data.provinceData[2],
        })
      } else {
        addressDetail = data
      }
      if (this.currentIndex === -1) {
        this[this.currentKey].push({
          addressId: addressDetail.addressId,
          userAddressDTO: addressDetail
        })
      }
      this[this.currentKey][this.currentIndex] = {
        addressId: addressDetail.addressId,
        userAddressDTO: addressDetail
      }
    },
    delEmail(index) {
      this.form.report.orderLinkList.splice(index, 1)
    },
    saveEmail() {
      if (!this.checkEmail()) {
        return
      }
      this.form.report.orderLinkList.push({
        linkEmail: this.currentEmail
      })
      this.isAddEmail = false
      this.currentEmail = ''
      this.showAddEmailErr = false
      return true
    },
    checkEmail() {
      if (!emailReg.test(this.currentEmail)) {
        this.showAddEmailErr = true
        this.errMsg = '请输入正确的邮箱格式'
        return
      }
      if (this.form.report.orderLinkList.some(v => v.linkEmail === this.currentEmail)) {
        this.showAddEmailErr = true
        this.errMsg = '您已添加此邮箱'
        return
      }
      return true
    },
    addEmail() {
      this.currentEmail = ''
      this.isAddEmail = true
      this.showAddEmailErr = false
      this.$nextTick(() => {
        this.$refs.emailInput.focus()
      })
    },
    copyApplyInfo(val) {
      if (!val) return
      this.form.reportCompanyNameCn = this.form.companyNameCn
      this.form.reportAddressCn = this.form.companyAddressCn
      this.form.reportCompanyNameEn = this.form.companyNameEn
      this.form.reportAddressEn = this.form.companyAddressEn
    },
    delFile(index) {
      this.form.application.testMemoImg.splice(index, 1)
    },
    delItem(index) {
      this.form.itemList.splice(index, 1)
    },
    addTestItem() {
      this.form.itemList.push({
        itemName: '',
        standardCode: '',
        testMemo: '',
        isDetermine: 0,
        sampleNoList: []
      })
    },
    getBasic() {
      this.loading = true
      getEnumBatch([
        // 报告语言
        {
          tableName: 'ORDER_BASE_INFO',
          colName: 'REPORT_LUA',
        },
        // 报告形式
        {
          tableName: 'ORDER_BASE_INFO',
          colName: 'REPORT_FORM',
        },
        // 周期要求
        {
          tableName: 'ORDER_BASE_INFO',
          colName: 'TEST_CYCLE',
        },
        // 化学标签
        {
          tableName: 'ORDER_SAMPLE',
          colName: 'OIQ_SAMPLE_TEST',
        },
      ], this.host.javaUrl).then(res => {
        this.loading = false
        if (res.resultCode === '0') {
          this.reportLuaList = res.data['ORDER_BASE_INFO.REPORT_LUA'].filter(v => v.enumCode !== 'OTHER' && v.enumCode !== 'ZNEN')
          this.reportFormList = res.data['ORDER_BASE_INFO.REPORT_FORM'].filter(v => v.enumCode !== 'OTHER')
          this.testCycleList = res.data['ORDER_BASE_INFO.TEST_CYCLE'].filter(v => {
            v.enumCode = Number(v.enumCode)
            if (v.enumCode === 4) v.enumName = '特急'
            if (v.enumCode !== 1) v.enumName = `${v.enumName}（费用+${v.remark}%）`
            return v.enumCode !== 5
          })
          this.chemicalTags = res.data['ORDER_SAMPLE.OIQ_SAMPLE_TEST']
        } else {
          this.$message.error(res.resultMsg)
        }
      }).catch(e => {
        this.loading = false
      })
    },
    qryBaseSample(businessCode) {
      this.sampleLoading = true
      qryBaseSample({ businessCode }, this.host.javaUrl + (this.isCs ? '/ticOrder' : '/ticMember')).then(res => {
        this.sampleLoading = false
        this.basicSample = res.data.items[0]
        this.basicSample.sampleFromGoup = {}
        this.basicSample.sampleFromDTOList.forEach(item => {
          item.showAttr = item.showAttr || {}
          this.basicSample[item.sampleKey] = ''
          this.basicSample[item.sampleKey + 'RemarkPage'] = ''
          if (item.type === 11) {
            this.basicSample[item.sampleKey] = []
          }
          if (!this.basicSample.sampleFromGoup[item.sampleGroup]) {
            this.basicSample.sampleFromGoup[item.sampleGroup] = [item.sampleKey]
          } else {
            this.basicSample.sampleFromGoup[item.sampleGroup].push(item.sampleKey)
          }
        })
        let sample = JSON.parse(JSON.stringify(this.basicSample))
        sample.sampleNo = new Date().getTime() + String.fromCharCode(65 + Math.floor(Math.random() * 26))
        this.sampleList = [sample]
        this.form.sampleList = this.sampleList
        // this.isSampleInit = true
        this.form.itemList.forEach(v => {
          v.sampleNoList = []
        })
      }).catch(e => {
        this.sampleLoading = false
      })
    },
    openAddress(currentKey, index) {
      this.isAdd = false
      this.currentKey = currentKey
      this.currentIndex = -1
      if (typeof index === 'number') {
        this.currentData = this[currentKey][index].userAddressDTO
        this.currentIndex = index
      }
      this.addressDialog = true
      this.addressListShow = this.hasUser && (!this.isCs || this.currentData.addressId || !this.currentData.companyAddress)
    },
    openEmail() {
      if (this.disabledAll) return
      this.isAdd = false
      this.invoiceData = Object.assign({}, this.invoiceData)
      this.emailDialog = true
      this.invoiceListShow = this.hasUser && (!this.isCs || this.invoiceData.invoiceId || !this.invoiceData.invoiceTitle)
    },
    getValidate(key) {
      return new Promise(resolve => this.$refs[key].validate(resolve))
    },
    getFormValidateArr() {
      let arr = []
      arr = arr.concat(this.$refs.Sample.getValidate(), this.$refs.ApplyInfo.getValidate(), this.getValidate('otherForm'), this.getValidate('orderInfoForm'))
      if (this.isAddBuyer) {
        arr.push(this.saveBuyer())
      }
      return arr
    },
    getData(isSave) {
      // if (this.invoiceData.invoiceTitle) {
      //   if (this.invoiceData.frontImg && typeof this.invoiceData.frontImg !== 'string') this.invoiceData.frontImg = this.invoiceData.frontImg.map(v => v.fileId).join(',')
      //   if (this.invoiceData.backImg && typeof this.invoiceData.backImg !== 'string') this.invoiceData.backImg = this.invoiceData.backImg.map(v => v.fileId).join(',')
      // }
      this.form.report.reportMethodMemo = this.form.report.reportMethod === 3 ? this.form.report.reportMethodMemo : ''
      this.form.orderInvoice.invoiceId = this.invoiceData.invoiceId
      this.form.orderInvoice.invoice = this.invoiceData
      this.form.orderInvoice.invoiceType = this.invoiceData.invoiceType
      this.form.application.applicationAttr.isDisputeMemo = this.form.application.applicationAttr.isDispute ? this.form.application.applicationAttr.isDisputeMemo : ''
      if (this.form.application.isRefundSample === '1') this.form.application.addressList = this.backAddressData
      this.form.type = isSave ? 1 : 0
      this.form.sampleList = this.$refs.Sample.getSample()
      this.form.itemList.forEach((v) => {
        if (v.sampleNoList) {
          v.sampleNoStr = v.sampleNoList
        }
      })
      const data = JSON.parse(JSON.stringify(this.form))
      data.orderNo = this.isCreate ? '' : this.orderNo
      if (this.isCreate) {
        data.tails = this.hasCs ? 1 : 0
      }
      console.log(data);
      return data
    },
    handleSubmit(isSave) {
      this.isSave = isSave
      this.form.invoiceId = this.invoiceData.invoiceTitle
      this.form.report.addressList = this.reportAddressData
      this.form.application.addressList = this.backAddressData
      if (this.form.report.reportTitleType === 0) {
        this.form.report.reportCompanyNameCn = this.form.application.companyNameCn
        this.form.report.reportAddressCn = this.form.application.companyAddressCn
        this.form.report.reportCompanyNameEn = this.form.application.companyNameEn
        this.form.report.reportAddressEn = this.form.application.companyAddressEn
      }
      if (this.form.report.reportTitleType === 1 && this.invoiceData.invoiceType !== 2) {
        this.form.report.reportCompanyNameCn = this.invoiceData.invoiceTitle
        this.form.report.reportAddressCn = this.invoiceData.regAddress
      }
      this.$nextTick(() => {
        Promise.all(this.getFormValidateArr()).then(res => {
          console.log(res);
          this.isSave = false
          if (res.every(v => v) && (!this.isAddEmail || this.saveEmail())) {
            if (!this.isCs && !this.checkNotice && isSave && this.loginSuccess) {
              this.$message.error('请接受 SGS服务通用条款')
              return
            }
            const data = this.getData(isSave)
            this.currentSaveData = data
            this.saveForm(data)
            this.checkNotice = false
          } else {
            this.$message.error('请填写必填项')
            setTimeout(() => {
              var isError = document.getElementsByClassName("el-form-item is-error");//此处的xunjia为自定义的类名称，可根据项目实际写或者不写
              var iserrortop = isError[0].getBoundingClientRect().top
              window.scrollTo(0, document.body.scrollTop + iserrortop)
            }, 100);
          }
        }).then(e => {
          this.isSave = false
        })
      })
    },
    saveForm(data) {
      if (this.isCs || this.loginSuccess) {
        // if (data.type === 1 && this.invoiceData.invoiceType === 2 && !this.invoiceData.taxNo) {
        //   this.$message.error('请填写身份证号码')
        //   this.emailDialog = true
        //   return
        // }
        this.$emit('saveForm', data)
        return
      }
      if (!this.checkRegister) {
        this.loading = false
        this.$alert('同意注册条款和隐藏协议后才可以继续提交', '', { confirmButtonText: '确定', center: true });
        return
      }
      this.showLoginCode()
    },
    showLoginCode() {
      this.codeShow = true
    },
    // 单个下载发票
    downloadFile(data) {
      this.downloadLoading = true
      this.apis.getDownUrl({fileId: data.fileId}).then(res => {
        window.open(res.data.fileUrl)
        this.downloadLoading = false
      }).catch(e => {
        this.downloadLoading = false
      })
    },
    // 批量下载发票
    generateTimeReqestNumber() {
      var date = new Date();
      return date.getFullYear().toString() + this.pad2(date.getMonth() + 1) + this.pad2(date.getDate()) + this.pad2(date.getHours()) + this.pad2(date.getMinutes()) + this.pad2(date.getSeconds());
    },
    pad2(n) { return n < 10 ? '0' + n : n },
    downloadReportList() {
      this.downloadLoading = true
      const that = this
      const files = this.invoiceFileListData.filter(v => v.fileId)
      const zipName = `sgsonline fapiao ${this.orderNo}_${this.generateTimeReqestNumber()}`
      const data = { files, zipName }
      const pid = "pid.mall";
      const pcode = "Z0zCnRE3IaY9Kzem";
      const pmd5 = md5((pid + pcode).toUpperCase(), "hex");
      const param = JSON.stringify(data) + pmd5.toUpperCase();
      const timestamp = new Date().valueOf();
      const sign = md5(param + timestamp, "hex");
      let accessToken = Cookies.get(tokenKey);
      let appId = "99999999";
      this.downloadPdf("/ticCenter/business/api.v0.platform/fileUpload/zipByOss", data, pid, sign, timestamp, appId, accessToken, that, 'downloadLoading', `${zipName}.zip`)
    },
    downloadPdf(url, data, pid, sign, timestamp, appId, accessToken, that, loadingKey, defaultName) {
      let headers = {
        pid,
        sign,
        timestamp,
        appId,
        accessToken
      }
      if(process.env.version) {
        headers.version = 'gray'
      }
      axios({
        data,
        url: this.apiUrl + url,
        method: "post",
        responseType: "blob",
        headers
      }).then(res => {
        that[loadingKey] = false
        let data = res.data;
        let fileReader = new FileReader();
        fileReader.onload = e => {
          try {
            let jsonData = JSON.parse(e.target.result);  // 说明是普通对象数据，后台转换失败
            if (res.resultCode === "9978") {
              redirect()
              return
            }
            this.$message.error(jsonData.resultMsg || '网络异常')
          } catch (err) {   // 解析成对象失败，说明是正常的文件流
            if (res && res.data && res.data.size) {
              var blob = new Blob([res.data], {
                type: "application/actet-stream;charset=utf-8"
              });
              let filename = "";
              var contentDisposition = res.headers["content-disposition"]; //从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
              if (contentDisposition) {
                var patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
                var result = patt.exec(contentDisposition);
                filename = decodeURIComponent(result[1]);
              }
              // IE下载
              if (window.navigator.msSaveOrOpenBlob) {
                var blobObject = new Blob([res.data], {
                  type: "application/actet-stream;charset=utf-8"
                });
                window.navigator.msSaveBlob(
                  blobObject,
                  filename || defaultName || "报价单.pdf"
                );
              } else {
                var downloadElement = document.createElement("a");
                var href = window.URL.createObjectURL(blob); //创建下载的链接
                downloadElement.style.display = "none";
                downloadElement.href = href;
                if (filename) {
                  downloadElement.download = decodeURI(filename).replace(
                    /\+/g,
                    " "
                  );
                } else {
                  downloadElement.download = defaultName || "报价单.pdf"; //下载后文件名
                }
                document.body.appendChild(downloadElement);
                downloadElement.click(); //点击下载
                setTimeout(() => {
                  document.body.removeChild(downloadElement); //下载完成移除元素
                  window.URL.revokeObjectURL(href); //释放掉blob对象
                }, 1000);
              }
            } else {
            }
          }
        }
        fileReader.readAsText(data)
      }).catch(e => {
        that[loadingKey] = false
      });
    },
  }
}
</script>

<style scoped lang="scss">
.chemicals-tags {
  margin-bottom: 20px;
  color: rgb(153, 153, 153);
  font-size: 14px;
  line-height: 18px;
  display: flex;
  align-items: center;
  .chemicals-tag {
    border-radius: 4px;
    background: rgba(202, 67, 0, 0.05);
    font-size: 14px;
    line-height: 30px;
    color: rgba(202, 67, 0, 0.7);
    cursor: pointer;
    padding: 0 19px;
    margin-left: 15px;
  }
}
.create-form {
  width: 100%;
  max-width: 1226px;
  position: relative;
  .buyer-tips {
    padding-left: 165px;
    color: rgb(255, 60, 60);
    font-size: 12px;
    line-height: 16px;
    position: relative;
    top: -13px;
  }
  .copy-btn {
    width: 142px;
    height: 36px;
    border: 1px solid rgb(202, 67, 0);
    border-radius: 4px;
    background: rgba(255, 102, 0, 0.05);
    color: rgb(202, 67, 0);
    margin-left: 15px;
    position: relative;
    top: 2px;
  }
  .yangpin-tab {
    height: 22px;
    background: #f6f6f6;
    border: 1px solid #dcdcdc;
    border-radius: 3px;
    font-size: 14px;
    font-family: Arial;
    font-weight: 400;
    color: #878787;
    text-align: center;
    line-height: 20px;
    max-width: 202px;
    padding: 0 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    p {
      line-height: 20px;
    }
  }
  .give-away-icon {
    display: inline-block;
    width: 23px;
    height: 23px;
    background: rgba(254, 102, 2, 1);
    border-radius: 50%;
    font-size: 14px;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 23px;
    margin-left: 10px;
    text-align: center;
  }
  .invoice-content {
    padding-top: 5px;
  }
  .report-form {
    width: 870px;
    border-radius: 4px;
    background: rgb(245, 245, 245);
    display: flex;
    flex-wrap: wrap;
    padding: 17px 0 0 26px;
    margin-bottom: 20px;
    .report-form-item {
      margin-right: 45px;
      .label {
        color: rgb(153, 153, 153);
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 9px;
      }
      .content {
        width: 360px;
        margin-bottom: 15px;
        color: rgb(51, 51, 51);
        font-size: 14px;
        line-height: 20px;
        min-height: 20px;
      }
    }
    .el-form-item {
      margin-bottom: 15px;
    }
    .el-input {
      width: 360px;
    }
  }
  .fixed-tab {
    position: fixed;
    width: 1226px;
    background: black;
    left: 0;
    right: 0;
    margin: auto;
    //top: calc(50vh - 169px);
  }
  .float-tabs {
    position: absolute;
    width: 180px;
    left: -200px;
    top: 0;
    .float-header {
      height: 40px;
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
      background: rgb(255, 255, 255);
      color: rgb(51, 51, 51);
      font-size: 14px;
      display: flex;
      align-items: center;
      padding-left: 11px;
      img {
        width: 15px;
        margin-right: 8px;
      }
    }
    .float-tab-list {
      box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
      background: rgb(248, 248, 248);
      font-size: 14px;
      line-height: 40px;
      color: #878787;
      padding: 8px 0 11px 43px;
      position: relative;
      &:before {
        content: "";
        position: absolute;
        width: 2px;
        height: 242px;
        top: 26px;
        left: 25.5px;
        background: rgb(227, 226, 226);
      }
      .float-tab-item {
        position: relative;
        span {
          cursor: pointer;
        }
        &:before {
          content: "";
          position: absolute;
          width: 7px;
          height: 7px;
          background: rgb(153, 153, 153);
          top: 17px;
          left: -20px;
          border-radius: 50%;
        }
        &.is-active {
          color: #CA4300;
          &:before {
            background: #CA4300;
          }
        }
      }
    }
  }
  .copy-btn {
    font-size: 12px;
    font-weight: 400;
    color: #ca4300;
    border: 1px solid #ca4300;
    padding: 2px;
    border-radius: 5px;
    cursor: pointer;
  }
  .redColor {
    color: #ca4303;
  }
  .member-tips {
    font-size: 14px;
    font-weight: 400;
    color: #878787;
    line-height: 22px;
    padding-left: 41px;
  }

  .btns {
    margin: 38px 0 20px;
    text-align: center;
    position: relative;
    .el-button {
      width: 180px;
      height: 44px;
      &:not(:last-child) {
        margin-right: 35px;
      }
    }
    .check-box {
      position: absolute;
      right: 26px;
      font-size: 14px;
      top: 12px;
    }
  }

  .staging-btn {
    border: 1px solid #AFAFAF;
    color: #333333;
  }

  .invoice-module {

    .edit-btn {
      margin-left: 20px;
      color: #CA4300;
      cursor: pointer;
    }
  }

  .invoice-btn {
    width: 142px;
    height: 36px;
    background: #FFFFFF;
    border: 1px solid #CA4300;
    border-radius: 4px;
    text-align: center;
    font-size: 14px;
    color: #CA4300;
    line-height: 34px;
    cursor: pointer;
    background: rgba(255, 102, 0, 0.05);
  }

  .invoice-item {
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    display: flex;

    .label {
      text-align: right;
      width: 165px;
      padding-right: 12px;
      flex-shrink: 0;
    }
  }

  .edit-address-btn {
    margin-left: 20px;
    color: #CA4300;
    cursor: pointer;
  }
  .address-content {
    display: flex;
    align-items: flex-start;

    .address-label {
      width: 220px;
      height: 34px;
      background: #FFFFFF;
      border: 2px solid #CA4300;
      position: relative;
      text-align: center;
      line-height: 30px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      flex-shrink: 0;

      img {
        position: absolute;
        bottom: 0;
        right: 0;
      }

      margin-right: 36px;
    }

    .address-detail {
      font-size: 14px;
      color: #333333;
      line-height: 34px;
    }


  }

  .memo-label {
    font-size: 14px;
    color: #333333;
    line-height: 1;
    margin-bottom: 11px;
  }

  .memo-textarea {
    margin-bottom: 14px;
  }

  .memo-textarea .el-textarea__inner {
    height: 60px;
    padding: 14px 15px;
  }

  .upload-btn {
    width: 150px;
    height: 32px;
    background: linear-gradient(0deg, #EEEEEE, #FFFFFF);
    border: 1px solid #B5B5B5;
    border-radius: 4px;
    padding: 0;
    text-align: center;
    line-height: 30px;
    color: #333333;
    margin-bottom: 20px;

    img {
      vertical-align: text-top;
      margin-right: 4px;
    }
  }

  .test-module {
    padding-bottom: 30px;

    .el-checkbox__label {
      font-size: 14px;
      color: #333333;
    }
    &.has-btn .module-label {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-right: 0;
      &:before {
        top: 10px;
      }
    }
  }
  .item-table {

  }

  .order-info {
    max-width: 1226px;
    margin: auto;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
  }

  .apply-info,
  .report-info {
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    width: 49%;
    max-width: 601px;
    padding: 28px 41px 13px 0;

    .module-label {
      margin-left: 25px;
    }

    .copy-btn {
      width: 90px;
      height: 24px;
      background: #FFFFFF;
      border: 1px solid #CA4300;
      border-radius: 4px;
      font-size: 12px;
      color: #CA4300;
      line-height: 22px;
      padding: 0;
      margin-left: 30px;
      position: absolute;
      top: -4px;
      left: 100px;
    }
  }

  .file-list {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 30px;

    a {
      text-decoration: underline;
      color: #CA4300;
    }

    .del-file {
      cursor: pointer;
      margin-left: 20px;
      color: #878787;
    }
  }

  .reportEmail {
    ::v-deep .el-form-item__content {
      display: flex;
      flex-wrap: wrap;
    }
    .el-input {
      width: 250px;
      margin-right: 16px;
    }

    .add-email,
    .cancel-add {
      width: 60px;
      height: 36px;
      font-size: 14px;
      line-height: 34px;
      padding: 0;
    }

    .cancel-add {}

    .add-email-input {
      position: relative;
      display: inline-block;

      .err-msg {
        color: #F56C6C;
        font-size: 12px;
        line-height: 1;
      }
    }

    .email-item {
      font-size: 14px;
      color: #333333;
      line-height: 40px;
      margin-right: 20px;
    }

    .del-email {
      color: #878787;
      margin-left: 20px;
    }
  }

  .spec-tips {
    font-size: 14px;
    font-weight: 400;
    color: #878787;
    line-height: 22px;
    padding-bottom: 30px;
  }

  .notice {
    text-align: center;
    font-size: 14px;
    color: #333333;
    line-height: 30px;
    margin: 20px 0;
  }
}
.report-content {
        padding-top: 29px;
        .report-list-tips {
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          line-height: 1px;
          margin-bottom: 40px;
        }
        .download-report-btn {
          color: #ca4300;
          cursor: pointer;
          text-decoration: underline;
          &:hover {
            color: red;
          }
        }
        .report-item {
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ca4300;
          line-height: 14px;
          margin-bottom: 30px;
          a {
            color: #ca4303;
          }
          .file {
            cursor: pointer;
          }
          &:hover {
            color: red;
          }
          &:last-child {
            margin-bottom: 0;
          }
          .icon {
            content: '';
            display: inline-block;
            width: 5px;
            height: 5px;
            background: #535353;
            border-radius: 50%;
            margin-right: 13px;
            position: relative;
            top: -3px;
          }
        }
      }
</style>
<style lang="scss">
.create-form {
  .reportTitleType {
    margin-bottom: 1px;
    &.is-error {
      margin-bottom: 10px;
    }
    .el-form-item__error {
      top: 29px;
    }
  }
  .yangpin-tab p {
    line-height: 20px;
  }
  td.yangpin-cell .cell {
    padding: 0;
    display: flex;
    justify-content: center;
  }
  .divider {
    width: 100%;
    border-bottom: 1px dashed rgb(210, 210, 210);
    margin-bottom: 24px;
  }
  .item-tips {
    width: 16px;
    height: 16px;
    position: absolute;
    right: -27px;
    top: 13px;
    cursor: pointer;
  }
}
.company-popper {
  min-width: 1000px !important;

  .autocomplete-item {
    display: flex;
    justify-content: space-between;

    span {
      display: block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      font-size: 12px;
    }

    .autocomplete-item-name {
      width: 250px;
    }

    .autocomplete-item-address {
      width: 490px;
    }

    .autocomplete-item-org,
    .autocomplete-item-date {
      width: 130px;
    }
  }
}

.invoice-tips {
  height: 140px;
  padding: 10px 0 0 0;

  .tips {
    color: #ca4300;
    background: rgba(255, 102, 0, 0.1);
    padding: 8px 14px;
  }
}

.invoice-popper.el-autocomplete-suggestion:not(.is-loading) {
  li:nth-child(odd) {
    background-color: #F3F3F3;
  }

  li:hover {
    background-color: #eef3fb;
  }
}

.create-form {
  .copy-checkbox {
    margin-left: 30px;
    color: #333333;

    .el-checkbox__inner {
      border-color: #ca4303;
    }
  }

  * {
    box-sizing: border-box;
  }

  .cs-form {

    .el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
    .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      display: none;
    }

    .lab-item.el-form-item.is-required:not(.is-no-asterisk) .el-form-item__label-wrap>.el-form-item__label:before,
    .lab-item.el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before {
      display: inline-block;
    }
  }

  .common-btn {
    height: 36px;
    background: rgba(255, 102, 0, 0.05);
    border: 1px solid #CA4300;
    border-radius: 4px;
    font-size: 14px;
    color: #CA4300;
    line-height: 34px;
    padding: 0 17px;
    cursor: pointer;
    display: inline-block;
    &.is-disabled {
      color: #C0C4CC;
      cursor: not-allowed;
      background-image: none;
      background-color: #FFF;
      border-color: #EBEEF5;
    }
  }

  .test-module {
    .el-checkbox__label {
      font-size: 14px;
      color: #333333;
    }

    .el-checkbox__inner {
      border: 1px solid #AFAFAF;
    }

    .el-checkbox__input.is-focus .el-checkbox__inner {
      border-color: #CA4300;
    }

    .el-table {
      margin-bottom: 19px;
      border-color: #D2D2D2;
    }

    .el-table td,
    .el-table th.is-leaf,
    .el-table--border,
    .el-table--group {
      border-color: #D2D2D2 !important;
    }

    .el-table--border::after,
    .el-table--group::after,
    .el-table::before {
      background-color: #D2D2D2 !important;
    }

    .el-table--border th.el-table__cell,
    .el-table__fixed-right-patch {
      border-bottom: 1px solid #D2D2D2;
    }

    .el-table--border .el-table__cell,
    .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed {
      border-right: 1px solid #D2D2D2;
    }

    .el-table th,
    .el-table td {
      padding: 0;
    }

    .el-table th .cell {
      padding: 0;
      text-align: center;
      line-height: 38px;
      height: 38px;
      background: #F5F5F5;
      font-size: 12px;
      font-weight: bold;
    }

    .el-table td .cell {
      padding: 0;
    }

    .el-table .index-cell {
      padding: 0;
      text-align: center;
    }

    .el-table .el-input__inner {
      border: none;
    }

    .el-table--enable-row-hover .el-table__body tr:hover>td {
      background: #fff !important;
    }
  }

  .el-textarea__inner {

  }

  .item-table .el-textarea__inner {
    border: none;
  }

  .other_report .el-textarea__inner {
    height: 60px;
    padding: 14px 15px;
  }

  .no-error.el-form-item .el-form-item__error {
    display: none;
  }

  .module {
    max-width: 1226px;
    margin: auto;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(0, 0, 0, 0.1);
    padding: 23px 26px 0 26px;
    margin-bottom: 26px;
  }

  .module-label {
    padding: 0 15px;
    position: relative;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    line-height: 1;
    margin-bottom: 24px;

    &:before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 3px;
      height: 16px;
      background: #CA4300;
    }

    .tips {
      font-size: 14px;
      color: #CA4300;
      line-height: 16px;
      margin-left: 20px;
      font-weight: normal;
    }
  }

  .el-input__inner {
    border: 1px solid #D6D6D6;
  }

  .el-form-item__label {
    color: #333333;
    font-weight: normal;
    font-size: 14px;
  }
  .itemName-form-item.el-form-item {
    margin-bottom: 0;
    &.is-error {
      margin-bottom: 20px;
    }
    .el-form-item__error {
      padding-left: 30px;
    }
  }
  .text-item.el-form-item {
    .el-form-item__label, .el-form-item__content {
      line-height: 1;
    }
  }
}
</style>